var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedgerLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0h17.8A7.2 7.2 0 0140 7.2V25H15V0zM0 10V7.2A7.2 7.2 0 017.2 0H10v10H0zm10 30H7.2A7.2 7.2 0 010 32.8V30h10v10zm30-10v2.8a7.2 7.2 0 01-7.2 7.2H30V30h10zm-25 0h10v10H15zM0 15h10v10H0z",
    fill: "#1C2E3E",
    fillRule: "evenodd"
  })));
}
export default SvgLedgerLogo;